import { type Vector } from "../utils/vector";

/*
    The thunderstorm's weather (0.98.4, owner decision, 31 October 2026: "thunderstorm mode, with the most changes
    imo. First, two things will happen, at the upper top of the map, 6 tornados will hit the entire game, in differentr
    places, these tornados rip the roof offf homes, and destroys glasses/windows on top of roofs, just like in
    architact, the roof becomes blown, of course, the roof wont blow on an actual apartment block made from cement,
    maybe some stuff goes, some animation for rooftops, byut they stay in place, same for police station, only the
    glass destorys. On the lower side of the map, where there is the river, it slowly floods, from the river to
    outward, the left half of the map, the island surrounded by the river, becomes completely flooded, and it spreadsd
    until the middle of downtown , also, hwne the water reaches the museum, iot shatters the middle dionsaurs and its
    part start being carried by water, animate it well please. also, add a few different cars in road downtown
    ,riversiden, the camp, some SUV's, some toyotas, some normal cars, that also get picked up by the water. Btw,
    tornados pick up loot and boxes and throw them somewhere else, it does nothing to cars tho, to players, it rotates
    them for 5 seconds and puts them in where the tornado ends. also, street lights flicker, and add small street rats
    that give 1 meat").

    Shared by the server (server/src/storm/stormManager.ts, which decides it all) and the page (which draws it:
    client/src/scripts/managers/tornadoFx.ts, floodRender.ts). Distances are game units, times ms.
*/

/** the tornadoes (six, over the north of the map) */
export const Tornadoes = Object.freeze({
    /** how many a storm match has */
    count: 6,
    /** the band of the map they cross: from the top, this share of the map's height down (the north: Uptown, the farm, the police station, the blocks, the prison) */
    band: 0.36,
    /** the first sets off this long after the match starts (everyone down from the planes), the next each `everyMs` after */
    firstMs: 75_000,
    everyMs: 38_000,
    /** how fast it crosses the ground (units a ms) */
    speed: 0.0095,
    /** its path's length, between */
    path: Object.freeze({ min: 420, max: 640 }),
    /** the funnel's radius: what's inside it is caught (roofs torn, boxes and loot lifted, players spun) */
    radius: 12,
    /** how far round it things are dragged towards it (loot and boxes slide in; players lean in) */
    pull: 34,
    /** a player caught is spun this long, then set down where the tornado's path ends (the owner's 5 seconds) */
    spinMs: 5_000,
    /** how high (m) a player is lifted while spun (the page's height bar is to it) */
    spinHeight: 9,
    /** a box or a piece of loot lifted spins round the funnel this long before it's thrown */
    liftMs: Object.freeze({ min: 1_200, max: 2_600 }),
    /** thrown this far from the funnel, between (boxes land where there's room) */
    throwReach: Object.freeze({ min: 28, max: 70 }),
    /** the roofs' glass is smashed and the roof torn when the funnel's edge comes this near the building's roof */
    roofReach: 6
});

/** the flood (the river over its banks, over the island and up into downtown) */
export const Flood = Object.freeze({
    /** the water starts over the banks this long after the match starts */
    startMs: 90_000,
    /** how fast it spreads out from the river (units a second) */
    rate: 1.15,
    /** how far it spreads north of the main river: to the middle of downtown (the owner), measured from the water's edge */
    reachNorth: 230,
    /** east of the branch (the camp's bank), a little way only */
    reachEast: 56,
    /** the island (south of the river, west of its branch) goes under entirely */
    reachIsland: Infinity,
    /** the field's cells (units): the flood's edge is reckoned on it */
    cell: 8,
    /** water deeper than this (units of spread past a spot) carries a car off; loot floats from the edge */
    carDepth: 12,
    /** how fast things drift with the water (units a second): loot, cars */
    drift: Object.freeze({ loot: 1.6, car: 0.9 }),
    /** the museum's middle dinosaur (`museum_sauropod`): shattered when the water reaches it */
    dinosaur: "museum_sauropod"
});

/** the roofs the tornadoes tear off: a building's, by its id, and the picture of what's left (its ceiling's torn frame) */
export const TornRoofs: Readonly<Record<string, string>> = Object.freeze({
    red_house: "red_house_ceiling_torn",
    red_house_v2: "red_house_ceiling_torn",
    barn: "barn_ceiling_torn"
});

/** a tornado as a player is sent it (the server's StormManager.data) */
export interface TornadoData {
    /** its number in the storm (0 to 5) */
    readonly id: number
    /** where its funnel is now */
    readonly position: Vector
    /** where its path ends (whoever it spins is set down there) */
    readonly end: Vector
    /** how far along it is (0 just formed, 1 dying away: the page draws it forming and fading) */
    readonly life: number
}

/** the storm as a player is sent it: the tornadoes crossing now, and how far the flood has spread (0 none yet) */
export interface StormData {
    readonly tornadoes: TornadoData[]
    /** how far the water has spread from the river's edge (units); 0: the river in its banks */
    readonly flood: number
}

/** a building's roof as the server sends it (`roof` in the building's data) */
export const enum RoofState {
    Whole,
    /** torn off by a tornado: its rooms open to the sky, what's left of it drawn (`TornRoofs`) */
    Torn
}
